<template>
  <Modal
    data-testId="modal-select-vehicle-model"
    title="Selecione o modelo do veículo"
    :active="activePopup"
  >
    <div>
      <vs-list>
        <vs-list-item
          v-for="item in vehicleModelOptions"
          :key="item.fipe_code"
          variant="success"
          :title="item.model_text"
          :subtitle="`${item.fipe_code}  /  ${item.year_model}`"
        >
          <template slot="avatar">
            <vs-radio
              color="success"
              v-model="selectedFipeCode"
              :vs-value="item.fipe_code"
              @change="changeFipeCode(item)"
              data-testId="fipe-radio"
            ></vs-radio>
          </template>
        </vs-list-item>
        <vs-list-item title="Nenhum dos modelos acima">
          <template slot="avatar">
            <vs-radio
              color="success"
              v-model="selectedFipeCode"
              :vs-value="'nenhum'"
              @change="changeFipeCode(null)"
              data-testId="none-radio"
            ></vs-radio>
          </template>
        </vs-list-item>
      </vs-list>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-w="12">
          <vs-button
            color="success"
            type="filled"
            class="mb-3 mt-4 confirm-button"
            @click="selectVehicleModel"
            :disabled="!selectedFipeCode"
            data-testId="confirm-button"
          >
            Confirmar
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
export default {
  name: 'ModalSelectVehicleModel',
  components: { Modal },
  props: {
    vehicleModelOptions: {
      type: Array,
      default: () => [],
    },
    reset: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedFipeCode: null,
      selectedVehicleModel: null,
      activePopup: false,
    };
  },
  watch: {
    reset() {
      if (this.reset) {
        this.selectedFipeCode = null;
        this.selectedVehicleModel = null;
      }
    },
    active(newVal) {
      this.activePopup = newVal;
    },
  },
  methods: {
    changeFipeCode(item) {
      this.selectedVehicleModel = item;
    },
    selectVehicleModel() {
      this.$emit('confirm', this.selectedVehicleModel);
    },
  },
};
</script>

<style lang="scss">
.confirm-button {
  border-radius: 1rem;
}
[data-testId='modal-select-vehicle-model'] .vs-popup--close {
  display: none !important;
}
</style>
